import { render, staticRenderFns } from "./TheForgetPwdForm.vue?vue&type=template&id=2a68b1f7"
import script from "./TheForgetPwdForm.vue?vue&type=script&lang=js"
export * from "./TheForgetPwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports